import { gql } from "@apollo/client"

const SEND_INVITATIONS_MUTATION = gql`
  mutation($input: SendInvitationsInput!) {
    sendInvitations(input: $input) { 
      success 
    }  
  }
`

export { SEND_INVITATIONS_MUTATION }
